import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDropzone } from "react-dropzone";
import ModalWrapperChildren from '@/views/components/Modal/ModalWrapperChildren';

import { useErrorFile, useAcceptedFile } from "@/utils/utils.js";

import api from "@/services/api";

import Alert from '@/views/components/Alert/Alert';

import styles from '@/views/pages/Departments/Departments.module.scss';

const ModalUploadDepartments = ({reloadDepartments, showModalUpload, setShowModalUpload}) => {
	const { dict } = useSelector(state => state.app);
	const [ requestIsPending, setRequestIsPending ] = useState(false);
	const [ error, setError ] = useState(null);
	const [ myFiles, setMyFiles ] = useState([]);
	
	const { acceptedFiles, fileRejections, getRootProps, getInputProps } = useDropzone({
		accept: {
			"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [ ".xlsx" ],
		},
		multiple: false,
	});

	const handleClose = () => {
		setShowModalUpload(false); 
		setMyFiles([]); 
		setError(null);
		reloadDepartments(); 
	};

	const getErrorFile = useErrorFile();

	const getAcceptedFile = useAcceptedFile();

	const addFile = () => {
		if (acceptedFiles.length > 0) {
			setRequestIsPending(true);
			const formData = new FormData();
			formData.append("departmentsFile", acceptedFiles[0]);

			api.post(`/departments/import/excel`, formData, {
				headers: {
					"Content-Type": "multipart/form-data",
				},
			}).then(res => {
				if(res.status === 200) {
					if(res.data.length > 0) {
						getErrorRows(res.data);
					} else if (res.data.length === 0 ) {
						setShowModalUpload(false);
						reloadDepartments();
					}
				}
				setRequestIsPending(false);
			});
		}
	};
	
	const getErrorRows = (errorRow) => {
		if(errorRow.length === 1 && errorRow[0] === 1) {
			setError(dict.dictionary.modalLoad.errors.headers);
		} else if (errorRow.length > 0) {
			const rows = errorRow.map(row => row).join(', ');
			const text = `${dict.dictionary.modalLoad.errors.rows} ${rows}`;
			setError(text);
		}
	};

	useEffect(() => {
		if(fileRejections.length > 0) {
			const err = fileRejections.map(f => f.errors.map(e => getErrorFile(e.code)));
			setError(err[0]);
		} else {
			setError('');	
		}
	}, [ fileRejections ]);

	useEffect(() => {
		if(acceptedFiles.length > 0) {
			setMyFiles(getAcceptedFile(acceptedFiles));
		}
	}, [ acceptedFiles ]);

	return (
		<ModalWrapperChildren 
			onClose={ () =>  handleClose() }
			setModalVisible={ setShowModalUpload }
			modalVisible={ showModalUpload }
			onConfirm={ () => addFile() }
			closeButtonName={ dict.cancel }
			confirmButtonName={ dict.load }
			disabled={ !acceptedFiles || acceptedFiles.length < 1 }
			requestIsPending={ requestIsPending }
			title={ dict.departments.modalUpload.title }
			description={ <><span> {dict.departments.modalUpload.desc.part1}</span>
				<ol className="modal-children__desc-list">
					<li> {dict.departments.modalUpload.desc.list.part1} </li>
					<li> {dict.departments.modalUpload.desc.list.part2} </li>
					<li> {dict.departments.modalUpload.desc.list.part3} </li>
				</ol>
				<span> {dict.departments.modalUpload.desc.part3}</span>
			</> }
			isLine
		>	
			<div>
				<p className="modal-children__info">{dict.departments.modalUpload.info}</p>
				{error && (
					<Alert
						variant='error'
						alertContent={ <>
							<strong>
								{dict.departments.modalUpload.error.part1}
							</strong>{dict.departments.modalUpload.error.part2}
							<ol className={ styles["load-departments--error-list"] }>
								<li>{dict.departments.modalUpload.error.part3.element1}</li>
								<li>{dict.departments.modalUpload.error.part3.element2}</li>
								<li>{dict.departments.modalUpload.error.part3.element3}</li>
							</ol>
						</> }
					/>
				)}
				{myFiles.length > 0 && (
					<Alert
						variant='info'
						alertContent={ <>{dict.departments.modalUpload.addedFile} <strong>{myFiles[0].key}</strong></> }
					/>
				)}
				{myFiles.length > 0 && (
					<p className='modal-children__info'>{ dict.departments.modalUpload.loadAnotherFile }</p>
				)}
				<section className="modal__load-dictionary--dropzone">
					<div { ...getRootProps({ className: "addletter__dropzone" }) }>
						<input { ...getInputProps() } />
						<p><span>{dict.departments.modalUpload.browse}</span> {dict.departments.modalUpload.dragFiles}</p>
					</div>	
				</section>
			</div>
			<Alert
				style={ { marginTop: '15px', marginBottom: '0px' } }
				variant='warning'
				alertContent={ <><strong>{dict.departments.modalUpload.warning.part1}</strong> {dict.departments.modalUpload.warning.part2}</> }
			/>
		</ModalWrapperChildren>
	);
};

export default ModalUploadDepartments;
